module.exports = __webpack_public_path__ + "static/media/obxWhite@3x.8d4199e0.png";